module.exports = __webpack_public_path__ + "static/img/6.560ba16.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/zh/6.png
// module id = yUmW
// module chunks = 0